module.exports = __webpack_public_path__ + "static/media/all-II-ups-ifu@3x.a430a82f.jpg";